module.exports = __webpack_public_path__ + "static/media/Emotions.4c852c41.mp4";